import DSButton from '@elliemae/ds-basic/Button';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import ShuttleBreadcrumb from './components/ShuttleBreadcrumb.js';
import OverflowList from './components/OverflowList.js';
import 'react';
import 'react-spring/web.cjs';
import '@elliemae/ds-basic/Breadcrumb';
import './animation/animationConfig.js';
import '@babel/runtime/helpers/esm/defineProperty';
import './AnimationState.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'constate';

var blockName = 'shuttle';
var headerBlockName = "".concat(blockName, "-header");
var listBlockName = "".concat(blockName, "-list");
var footerBlockName = "".concat(blockName, "-footer");
var ShuttleContainer = aggregatedClasses('div')(blockName); // wrapper

var ShuttleWrapper = aggregatedClasses('div')("".concat(blockName, "-wrapper")); // header

var ShuttleHeader = aggregatedClasses('div')(headerBlockName);
var ShuttleHeaderBreadcrumb = aggregatedClasses(ShuttleBreadcrumb)(headerBlockName, 'breadcrumb');
var ShuttleHeaderSearchToggle = aggregatedClasses(DSButton)(headerBlockName, 'search-toggle'); // list

var ShuttleList = aggregatedClasses('div')(listBlockName, null, function (_ref) {
  var showPulse = _ref.showPulse;
  return {
    'show-pulse': showPulse
  };
});
var ShuttleListPanel = aggregatedClasses('div')(listBlockName, 'panel', function (_ref2) {
  var open = _ref2.open;
  return {
    open: open
  };
});
var Overflow = aggregatedClasses(OverflowList)(listBlockName, 'overflow', function (_ref3) {
  var empty = _ref3.empty,
      searching = _ref3.searching;
  return {
    empty: empty,
    searching: searching
  };
});
var EmptyMessage = aggregatedClasses('span')(listBlockName, 'empty-message');
var LoadingList = aggregatedClasses('div')(listBlockName, 'loading-list'); // footer

var ShuttleFooter = aggregatedClasses('div')(footerBlockName);
var ShuttleFooterActions = aggregatedClasses('div')(footerBlockName, 'actions');
var ShuttleFooterCounter = aggregatedClasses('span')(footerBlockName, 'counter');

export { EmptyMessage, LoadingList, Overflow, ShuttleContainer, ShuttleFooter, ShuttleFooterActions, ShuttleFooterCounter, ShuttleHeader, ShuttleHeaderBreadcrumb, ShuttleHeaderSearchToggle, ShuttleList, ShuttleListPanel, ShuttleWrapper };
//# sourceMappingURL=classedComponents.js.map
